<template src="./companyinspectionsetting.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {},
    data() {
      return {
        FleetSubscription: {},
        CountCustomInspection: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        CompanyInspections: [],
        Categories: [],
        VehicleClasses: [],
        Classes: [],
        Category: 0,
        ClassID: 3,
        AddClassId:0,
        ClassSubmitted:false,
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.GetCompanySubscription();
      this.GetVehicleDefaultClasses();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },

    methods: {
      GetVehicleDefaultClasses(){
          var obj = { token: localStorage.getItem("token"), simple_list:false,  type:'fleet_inspection_category' };
          Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, obj).then((Response) => {
            if (Response.data.success) {
              this.Classes = Response.data.records;
            }
          });        
      },
      GetCategory() {
        Axios.post(Endpoints.VehicleInspections.GetCategoriesList, {
          token: localStorage.getItem("token"),
          class_id: this.ClassID,
        }).then((Response) => {
          if (Response.data.success) {
            this.Categories = Response.data.InspectionCategories;
            this.Categories.forEach((element, index) => {
              if (index == 0) {
                this.Category = element.id;
                var catID = element.id;
                this.GetCompanyInspections(catID);
              }
            });
          }
        });
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isHGV = FleetSubscriptionModules.HGV;
        if (isHGV) {
          this.GetVehicleClasses();
        } else {
          this.$router.push("/settings");
        }
      },
      GetVehicleClasses(ClassID = 0) {
        if (localStorage.getItem("InspectionsClasses")) {
          this.VehicleClasses = JSON.parse(
            localStorage.getItem("InspectionsClasses")
          );          
        } else {
          Axios.post(Endpoints.VehicleInspections.GetVehicleClasses, {
            token: localStorage.getItem("token"),
          }).then((Response) => {
            if (Response.data.success) {
              this.VehicleClasses = Response.data.records;
            }
          });
        }

        if(ClassID > 0){
          this.GetClassCategoriesList(ClassID);
        }else{
          this.VehicleClasses.forEach((element, index) => {
            if (index == 0) {
              this.GetClassCategoriesList(element.id);
            }
          });
        }
        
      },
      EnableEditMode() {
        this.Editmode = true;
      },
      DisableEditMode() {
        this.Editmode = false;
      },
      GetCompanyInspections(catID) {
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleInspections.GetCompanyInspections, {
          token: localStorage.getItem("token"),
          fleet_inspection_category_id: catID,
        }).then((Response) => {
          this.ShowLoader = false;
          this.CompanyInspections = Response.data.CompanyInspections;
          if (typeof this.CompanyInspections[0] != "undefined") {
            this.CompanyInspections[0]["required"] = true;
          }
          this.CountCompanyCustomInspections();
        });
      },
      CountCompanyCustomInspections() {
        this.CountCustomInspection = this.CompanyInspections.length;
      },
      SaveCompanyInspections() {
        var error = false;
        this.CompanyInspections.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Inspection Name", "", "error");
              return true;
            }
          }
        });
        if (!error) {
          this.Submitted = true;
          this.CompanyInspections.fleet_inspection_category_id = this.Category;
          Axios.post(Endpoints.VehicleInspections.SaveCompanyInspections, {
            token: localStorage.getItem("token"),
            CompanyInspections: this.CompanyInspections,
          }).then((Response) => {
            this.Submitted = false;
            this.GetCompanyInspections();
            this.$swal(
              "Vehicle Inspections Saved Successfully",
              "",
              "success"
            ).then(() => {
              this.GetInspectionsList(this.Category);
            });
          });
        }
      },
      DeleteCompanyInspections(checkid) {
        this.$swal({
          title: "Are you sure You want to delete this Check List?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleInspections.DeleteCompanyInspections, {
              token: localStorage.getItem("token"),
              id: checkid,
            }).then((Response) => {
              this.CompanyInspections.forEach((value, index) => {
                if (value.id == checkid) {
                  this.CompanyInspections.splice(index, 1);
                }
              });
              this.CountCompanyCustomInspections();
              this.$swal(
                "Inspection Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
                this.GetInspectionsList(this.Category);
              });
            });
          }
        });
      },
      AddCustomVehicleInspection() {
        if (
          this.FleetSubscription &&
          this.FleetSubscription.pmi_check_count_per_category >
            this.CountCustomInspection
        ) {
          this.Editmode = true;
          var obj = {
            custom: 1,
            id: 0,
            name: "",
            fleet_inspection_category_id: this.Category,
            position: this.CompanyInspections.length + 1,
            required: 1,
            status: 1,
          };
          this.CompanyInspections.push(obj);
          this.CountCompanyCustomInspections();
        } else {
          this.$swal(
            "You have reached your subscription's maximum allowed PMI checks. Please contact us to add more checks",
            "",
            "error"
          );
        }

      },
      GetInspectionsList(catID) {
        this.CompanyInspections = [];
        this.Category = catID;
        $(".cat-links").removeClass("active");
        $("#catid" + catID).addClass("active");
        this.Editmode = false;
        this.GetCompanyInspections(catID);
      },
      GetClassCategoriesList(classID) {
        this.CompanyInspections = [];
        this.Categories = [];
        this.ClassID = classID;
        setTimeout(() => {
          $(".class-links").removeClass("active");
          $("#class_id" + classID).addClass("active");
        }, 500);
        this.Editmode = false;
        this.GetCategory();
      },
      addNewClass() {
        var error = false;
        if (this.AddClassId <= 0) {
          error = true;
          this.$swal("Please select template", "", "error");
          return true;
        }
        if (!error) {
          this.ClassSubmitted = true;
          Axios.post(Endpoints.VehicleInspections.AddNewClass, {
            token: localStorage.getItem("token"),
            AddClassId: this.AddClassId,
          }).then((Response) => {
            localStorage.removeItem('InspectionsClasses');
            this.GetVehicleClasses(this.AddClassId);
            this.GetVehicleDefaultClasses();
            this.AddClassId = 0;
            this.ClassSubmitted = false;
            this.$root.$emit("reloadInspectionClass");
            $('#add-new-class .btn-primary').trigger('click');
            this.$swal(
              "Vehicle Inspection Template  Added Successfully",
              "",
              "success"
            ).then(() => {});
          });
        }
      },
    },
  };
</script>

<style scoped>
  .activeAdd {
    text-align: center;
    background: #8f4f88 !important;
    color: #fff;
    overflow: hidden;
  }
  .text-primary {
    color: #8f4f88 !important;
  }
  .deleteClass {
    font-size: 16px;
    margin: 2px 0 0 20px;
  }
</style>